import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhoneCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2"
    />
    <path
      fill="currentColor"
      d="M21.2 9.4 18.3 9a1 1 0 0 0-1 .6l-1 3.1a.9.9 0 0 0 .4 1l1.6 1a5.1 5.1 0 0 1-2.5 3.8l-1.4-1.2a.9.9 0 0 0-1-.1l-3 1.5a.9.9 0 0 0-.3 1l.9 2.8a.9.9 0 0 0 1 .6c7-.7 10.6-6 10-13a.8.8 0 0 0-.8-.7"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhoneCircleOutlineSVG);
ForwardRef.displayName = "IconPhoneCircleOutline";
export { ForwardRef as IconPhoneCircleOutline };
